import { usePostNotificationsReadAll } from '@sit/openapi';
import { use, useCallback } from 'react';
import { NotificationHandlerContext } from '../NotificationHandlerContext';

export function useSetNotificationsAsRead() {
  const { markAsRead } = use(NotificationHandlerContext);
  const { mutate: markAsReadMutation } = usePostNotificationsReadAll();
  const setAsRead = useCallback(() => {
    markAsRead();
    markAsReadMutation({});
  }, [markAsRead, markAsReadMutation]);
  return setAsRead;
}
